import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosConfig from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
import { SESSION_QUERY_KEY } from './CheckSessionHook'

type DeleteSuccessorDocInput = {
  uuid: string;
  email: string;
  password: string;
};

export const useDeleteSuccessorDoc = (
  options?: UseMutationOptions<any, Error, DeleteSuccessorDocInput, unknown>,
  withoutToast?: boolean
) => {
  return useMutation<any, Error, DeleteSuccessorDocInput, unknown>({
    mutationKey: ["successorDocDelete"],
    mutationFn: async ({ uuid, email, password }) => {
      return axiosConfig
        .delete(`/successors/docs/${uuid}`, { data: { email, password } })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      if (!withoutToast) {
        Toast({
          message: "Ładowanie...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "successorDocDelete",
        });
      }
      if (options?.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Pomyślnie usunięto dokument",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "successorDocDelete",
        });
      }
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["successors", "docs"] });
      }, 100);

      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      if (!withoutToast) {
        Toast({
          message: "Błąd podczas usuwania dokumentu",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "successorDocDelete",
        });
      }
      options?.onError?.(error, variables, context);
    },
  });
};
